module.exports = __webpack_public_path__ + "img/title-2.7251b5ed.png";